module.exports = __webpack_public_path__ + "static/media/nuevovallarta.abc65e67.jpg";